import { z } from 'zod';

import { LosId, WriteoffId } from '../../BrandedIds';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';
import { zodBrandedString, zodBrandedUuid } from '../../utils';

export const ExportableWriteoff = z
  .object({
    id: zodBrandedUuid<WriteoffId>(),
    loanId: zodBrandedString<LosId>(),

    effectiveDate: zodTemporalPlainDate,
    status: z.enum(['active']),
    escrow: z.number(),
    suspense: z.number(),
    comment: z.string().optional(),
    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'Writeoff' });

export type ExportableWriteoff = z.infer<typeof ExportableWriteoff>;
